import * as ApiModels from '@typings/api-models';
import UserImage from '@/components/UserImage';
import pluralize from 'pluralize';
import s from './Message.module.scss';

type Props = {
  replies?: (Pick<ApiModels.Message, 'id'> & {
    owner: Pick<ApiModels.Person, 'id' | 'name'> & {
      primaryColour: { hex: string } | null;
      image: { url: string } | null;
    };
  })[];
  size: number;
};

const Participants: React.FC<Props> = ({ replies, size }) => {
  const uniqueReplies = replies?.filter((r, i, a) => a.findIndex(_r => _r.owner.id === r.owner.id) === i);

  return (
    <div className={s.participants}>
      <div className={s.people}>
        {uniqueReplies?.slice(0, 4)?.map?.(r => (
          <div key={r.id} className={s.person}>
            <UserImage size={size} name={r.owner.name} url={r.owner.image?.url} color={r.owner.primaryColour?.hex || null} />
          </div>
        ))}
      </div>

      {replies && replies.length > 0 && (
        <span>
          {replies.length} {pluralize('reply', replies.length)}
        </span>
      )}
    </div>
  );
};

export default Participants;
